module.exports = __webpack_public_path__ + "static/media/Payroll3.b18bea65.svg";